export default {
  common: {
    credits: 'Tegoed',
    next_training: 'Volgende training',
    actions: {
      cancel: 'ANNULEER',
      delete: 'VERWIJDER',
      edit: 'BEWERK',
      save: 'SLA OP',
      send: 'VERSTUUR',
      prompt: 'Weet je het zeker?'
    },
    errors: {
      save_failed: 'OPSLAAN MISLUKT'
    },
    sub_end_warning_day_one: 'Het abonnement verloopt over {{count}} dag.',
    sub_end_warning_day_other: 'Het abonnement verloopt over {{count}} dagen.',
    sub_end_warning_week: 'Het abonnement verloopt over {{count}} weken.',
    sub_end_warning_message: ' Neem contact op met TIFA Sports om te verlengen en door te ontwikkelen!'
  },

  household: {
    title: 'Mijn gezin',
    pick_child: 'Kies een kind',
    pending_title: 'Aanmelding ontvangen',
    pending_text: 'TIFA Sports bekijkt je aanmelding en wijst binnenkort een groep en abonnement toe. Je krijgt daarna bericht. Tot die tijd kun je nog niet boeken.',
    no_group: 'Nog geen groep',
    switch_child: 'Wissel van kind',
    delete_account: 'Account verwijderen',
    delete_confirm: 'Weet je zeker dat je je account wilt verwijderen?',
    deleted: 'Je account en de gegevens van je kinderen zijn verwijderd.',
    delete_requested: 'Je verzoek is verstuurd. TIFA Sports verwijdert je account binnen 30 dagen en neemt contact op als er nog iets openstaat.',
  },

  signup: {
    link: 'Nieuw bij TIFA? Account aanmaken',
    intro: 'Vul je e-mailadres in. Je krijgt een link om je account en dat van je kind(eren) aan te maken.',
    send: 'Stuur link',
    sent: 'Check je mail: we hebben je een link gestuurd (1 uur geldig).',
    mail_exists: 'Dit e-mailadres heeft al een account. Log in of gebruik "Wachtwoord vergeten".',
    title: 'Account aanmaken',
    parent: 'Jouw gegevens',
    children: 'Kinderen',
    child: 'Kind',
    add_child: '+ Nog een kind',
    remove_child: 'Verwijder',
    pass: 'Wachtwoord (minimaal 8 tekens)',
    pass_check: 'Herhaal wachtwoord',
    pass_mismatch: 'De wachtwoorden zijn niet hetzelfde',
    consent_terms: 'Ik ga akkoord met het privacybeleid van TIFA Sports',
    privacy_link: 'Lees het privacybeleid',
    consent_photos: "TIFA Sports mag foto's van mijn kind(eren) maken tijdens trainingen en toernooien",
    submit: 'Account aanmaken',
    expired: 'Deze link is verlopen of al gebruikt. Vraag een nieuwe aan via "Account aanmaken".',
    error: 'Aanmelden is niet gelukt',
    errors: {
      missing_parent_name: 'Vul je voornaam in',
      pass_too_short: 'Het wachtwoord moet minimaal 8 tekens hebben',
      missing_consent: 'Ga akkoord met het privacybeleid',
      children_count: 'Vul minimaal 1 kind in (maximaal 6)',
      missing_child_name: 'Vul de voornaam van elk kind in',
      invalid_birth_date: 'Controleer de geboortedatum',
      mail_exists: 'Dit e-mailadres heeft al een account',
      signup_expired: 'Deze link is verlopen. Vraag een nieuwe aan.',
    }
  },

  trial: {
    title: 'Gratis proeftraining',
    intro: 'Kom vrijblijvend een keer meetrainen bij TIFA PARC in Rotterdam. Kies het programma, een moment en vul je gegevens in.',
    step_program: 'Programma',
    step_moment: 'Moment',
    step_details: 'Gegevens',
    programs: { peuter: 'Peutervoetbal', fundament: 'TIFA Fundament', institute: 'TIFA Sports Institute' },
    no_slots: 'Er zijn de komende weken geen plekken vrij. Bel of mail ons, dan zoeken we samen een moment.',
    full: 'Vol',
    left_one: 'nog {{count}} plek',
    left_other: 'nog {{count}} plekken',
    child_name: 'Naam van je kind',
    parent_name: 'Jouw naam',
    message: 'Opmerking (optioneel)',
    consent: 'Ik ga akkoord dat TIFA Sports deze gegevens gebruikt voor de proeftraining',
    submit: 'Proeftraining aanvragen',
    done_title: 'Tot op het veld!',
    done_text: 'We hebben een bevestiging gestuurd naar {{email}}. Neem sportkleding, voetbalschoenen of gympen en water mee.',
    back: 'Terug naar de app',
    link: 'Gratis proeftraining plannen',
    error: 'Er ging iets mis. Probeer het opnieuw of bel ons.',
    errors: {
      already_requested: 'Je hebt al een proeftraining aangevraagd. Wil je een ander moment? Antwoord op de bevestigingsmail.',
      busy: 'Het is erg druk. Probeer het morgen opnieuw of bel ons.',
      slot_full: 'Dit moment is net vol geraakt. Kies een ander moment.',
      invalid_slot: 'Dit moment is niet meer beschikbaar. Kies een ander moment.',
      invalid_email: 'Controleer het e-mailadres',
      missing_phone: 'Vul je telefoonnummer in',
      missing_consent: 'Ga akkoord om door te gaan',
      invalid_birth_date: 'Controleer de geboortedatum',
      missing_child_name: 'Vul de naam van je kind in',
      missing_parent_name: 'Vul je naam in',
    }
  },

  login: {
    change_pass: 'Verander wachtwoord',
    confirm_change_pass: 'Als het ingevulde email-adres bekend is, heb je een recovery-mail ontvangen',
    forgot_pass: 'Wachtwoord vergeten?',
    go_back: 'Terug naar inloggen',
    persist: 'Blijf ingelogd',
  },

  user: {
    fields: {
      name: 'VOORNAAM',
      last_name: 'ACHTERNAAM',
      birth_date: 'GEBOORTEDATUM',
      phone_nr: 'TELEFOONNUMMER',
      team: 'CLUB / TEAM',
      language: {
        _label: 'TAAL',
        en: 'English',
        nl: 'Nederlands'
      },
      avatar: 'PROFIELFOTO',
    },
    change_pass: 'VERANDER WACHTWOORD',
  },
  
  slot: {
    label: 'BOEKINGEN',

    actions: {
      book: 'RESERVEER',
      cancel: 'CANCEL BOEKING'
    },

    available: 'TIJD SLOTS',
    booked: 'BOEKINGEN',
    no_refund: 'Je krijg je credit niet vergoed'
  },

  video: {

  },

  rules: {

  },

  feedback: {
    fields: {
      type: {
        _label: '',
        _empty: 'Kies een categorie...',
        Bug: 'Bug',
        Design: 'Design',
        Functionaliteit: 'Functionaliteit',
        Overig: 'Overig'
      }
    },
    descriptions: {
      Bug: 'Heb je een probleem ontdekt in de app? Laat ons graag zo duidelijk mogelijk weten wat je precies deed, wat er gebeurde, en wat je had verwacht dat er zou gebeuren',
      Design: 'Heb je tips voor het ontwerp? Laat ons weten wat er beter kan!',
      Functionaliteit: 'Mis je iets, of heb je tips voor hoe een bepaalde functionaliteit zou moeten werken? We horen het graag!',
      Overig: 'Heb je algemene tips of suggesties? Laat het ons weten!'
    },

    type_choice: 'Kies het soort feedback dat je wilt geven:',
    reload_description: 'Nieuwe feature niet beschikbaar?',
    reload_text: 'HERLAAD DE APP',
    thanks_text: 'Bedankt voor je feedback!',
    error_text: 'Er is iets foutgegaan bij het versuren van je feedback; laat het ons weten via info@tifasports.com'
  },

  categories: {
    label: 'Categorieën',
    hero_text: {
      flash: 'Een speler die bliksemsnel bij de Hulk-categorie wilt komen',
      batman: 'Peutervoetbal, 4 tot 6 jaar oud',
      hulk: 'Een speler die onder eerste divisie niveau speelt, amateur',
      black_panther: 'Een speler die op eerste divisie niveau speelt, zowel BVO als hoog-amateur',
      wolverine: 'Een speler die op Eredivisieniveau speelt, BVO',
      spiderman: 'Een topspeler die speelt bij Feyenoord, Ajax, PSV, AZ, BVO',
      iron_man: 'Een speler die international is, BVO'
    }
  },

  about: {
    label: 'Over ons...'
  }
}
